export default __webpack_public_path__ + "static/GESSTwoBold-Bold-44dd1352c99bb6fe54049054e84fc1d3.ttf";